import { IToken } from "../../models/index";

export interface IAuthState {
    authInfo: IToken | null,
    tokenHex: string,
    isAuthenticated: boolean
}

export class Auth implements IToken {
    constructor() {
        this.access_token = "";
        this.expires = "";
        this.expires_in = "0";
        this.refresh_token = "";
        this.refresh_expires = "";
    }

    access_token: ""
    expires: "";
    expires_in: "0";
    refresh_token: "";
    refresh_expires: "";
}